module.exports = __webpack_public_path__ + "static/media/POCURRY_MENU-normal.28de3b8c.png";